import React, { useEffect } from 'react';
import { Button, Card, Form, Space, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import EmployeeForm from '../../components/EmployeeForm';
import { useEmployees } from '../../hooks/useEmployees';
import { useDepartments } from '../../hooks/useDepartments';

const EmployeeEditView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { activeEmployee, fetchEmployee, updateEmployee, isLoading } = useEmployees();
  const { departments, positions, fetchDepartments, fetchPositions } = useDepartments();

  useEffect(() => {
    if (id) {
      fetchEmployee(Number(id));
      fetchDepartments();
      fetchPositions();
    }
  }, [id]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    const updated = await updateEmployee(Number(id), {
      ...values,
      hireDate: values.hireDate?.format('YYYY-MM-DD'),
      terminationDate: values.terminationDate?.format('YYYY-MM-DD'),
    });
    if (updated) navigate(`/hr/employees/${id}`);
  };

  if (isLoading && !activeEmployee) return <Spin className="p-6" />;

  return (
    <div className="p-6">
      <Card
        title="Edit Employee"
        extra={
          <Space>
            <Button onClick={() => navigate(`/hr/employees/${id}`)}>Cancel</Button>
            <Button type="primary" onClick={handleSubmit} loading={isLoading}>Save Changes</Button>
          </Space>
        }
      >
        <EmployeeForm
          form={form}
          initial={activeEmployee ?? undefined}
          departments={departments}
          positions={positions}
        />
      </Card>
    </div>
  );
};

export default EmployeeEditView;
